export default {
  fact: {
    marginRight: 20,
    marginLeft: 20,
    marginTop: 10,
    marginBottom: 10,
    textAlign: 'center',
  },
  facts: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'start',
    marginTop: 15,
    marginLeft: 25,
  },
};
